var _messages;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { FormattedRelativeTime } from 'react-intl';
import Alert from '../../components/Alert';
import Translate from '../../components/Translate';
import translate from '../../lib/utils/translate';
import { selectUnit } from '@formatjs/intl-utils';

/**
 * Get a message
 */
var get = function get(id) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  id = typeof id === 'string' && id.toLowerCase();
  var message = typeof messages[id] === 'function' ? messages[id](values) : '';
  return message;
};

/**
 * Map a message to a value of a specific type
 */
var getValue = function getValue(value, valueType, currency, intl) {
  switch (valueType) {
    case 'currency':
      return get('label.responsible-gaming.currency', {
        intl: intl,
        value: value,
        currency: currency
      });
    case 'minutes':
      return get('label.responsible-gaming.minutes', { intl: intl, value: value });
    case 'hours':
      return get('label.responsible-gaming.hours', { intl: intl, value: value });
    case 'days':
      return get('label.responsible-gaming.days', { intl: intl, value: value });
    case 'weeks':
      return get('label.responsible-gaming.weeks', { intl: intl, value: value });
    case 'months':
      return get('label.responsible-gaming.months', { intl: intl, value: value });
    case 'years':
      return get('label.responsible-gaming.years', { intl: intl, value: value });
  }
};

var messages = (_messages = {}, _defineProperty(_messages, 'header.responsible-gaming.deposit', function headerResponsibleGamingDeposit() {
  return React.createElement(Translate, { id: 'label.type.Deposit', defaultMessage: 'Deposit limit' });
}), _defineProperty(_messages, 'header.responsible-gaming.netloss', function headerResponsibleGamingNetloss() {
  return React.createElement(Translate, { id: 'label.type.NetLoss', defaultMessage: 'Loss limit' });
}), _defineProperty(_messages, 'header.responsible-gaming.wager', function headerResponsibleGamingWager() {
  return React.createElement(Translate, { id: 'label.type.Wager', defaultMessage: 'Wager limit' });
}), _defineProperty(_messages, 'header.responsible-gaming.logintime', function headerResponsibleGamingLogintime() {
  return React.createElement(Translate, { id: 'label.type.LoginTime', defaultMessage: 'Login time limit' });
}), _defineProperty(_messages, 'header.responsible-gaming.block', function headerResponsibleGamingBlock() {
  return React.createElement(Translate, { id: 'label.type.Block', defaultMessage: 'Block account' });
}), _defineProperty(_messages, 'header.responsible-gaming.realitycheck', function headerResponsibleGamingRealitycheck() {
  return React.createElement(Translate, { id: 'label.type.RealityCheck', defaultMessage: 'Reality check' });
}), _defineProperty(_messages, 'header.responsible-gaming.loginperiodblock', function headerResponsibleGamingLoginperiodblock() {
  return React.createElement(Translate, {
    id: 'label.type.LoginPeriodBlock',
    defaultMessage: 'LoginPeriodBlock'
  });
}), _defineProperty(_messages, 'header.responsible-gaming.session', function headerResponsibleGamingSession() {
  return React.createElement(Translate, { id: 'label.type.Session', defaultMessage: 'Play session limit' });
}), _defineProperty(_messages, 'header.responsible-gaming.selfexclude', function headerResponsibleGamingSelfexclude() {
  return React.createElement(Translate, { id: 'label.type.SelfExclude', defaultMessage: 'SelfExclude' });
}), _defineProperty(_messages, 'header.responsible-gaming.timeperiod', function headerResponsibleGamingTimeperiod() {
  return React.createElement(Translate, { id: 'label.type.TimePeriod', defaultMessage: 'TimePeriod' });
}), _defineProperty(_messages, 'header.responsible-gaming.productsessioncasino', function headerResponsibleGamingProductsessioncasino() {
  return React.createElement(Translate, {
    id: 'label.type.ProductSessionCasino',
    defaultMessage: 'Product Session Casino'
  });
}), _defineProperty(_messages, 'header.responsible-gaming.timespan.0', function headerResponsibleGamingTimespan0() {
  return React.createElement(Translate, { id: 'label.each_transaction', defaultMessage: 'Each transaction' });
}), _defineProperty(_messages, 'header.responsible-gaming.timespan.1', function headerResponsibleGamingTimespan1() {
  return React.createElement(Translate, { id: 'label.each_day', defaultMessage: 'Each day' });
}), _defineProperty(_messages, 'header.responsible-gaming.timespan.7', function headerResponsibleGamingTimespan7() {
  return React.createElement(Translate, { id: 'label.each_week', defaultMessage: 'Each week' });
}), _defineProperty(_messages, 'header.responsible-gaming.timespan.30', function headerResponsibleGamingTimespan30() {
  return React.createElement(Translate, { id: 'label.each_month', defaultMessage: 'Each month' });
}), _defineProperty(_messages, 'message.responsiblegaming.current-limit', function messageResponsiblegamingCurrentLimit() {
  return React.createElement(Translate, {
    id: 'message.responsiblegaming.current-limit',
    defaultMessage: 'Current limit'
  });
}), _defineProperty(_messages, 'message.responsiblegaming.remaining-limit', function messageResponsiblegamingRemainingLimit() {
  return React.createElement(Translate, {
    id: 'message.responsiblegaming.remaining-limit',
    defaultMessage: 'Remaining amount'
  });
}), _defineProperty(_messages, 'message.responsiblegaming.remaining-time', function messageResponsiblegamingRemainingTime() {
  return React.createElement(Translate, {
    id: 'message.responsiblegaming.remaining-time',
    defaultMessage: 'Remaining time'
  });
}), _defineProperty(_messages, 'action.responsible-gaming.save-limits', function actionResponsibleGamingSaveLimits() {
  return React.createElement(Translate, {
    id: 'action.responsible-gaming.save-limits',
    defaultMessage: 'Save limits'
  });
}), _defineProperty(_messages, 'action.responsible-gaming.reset-limit', function actionResponsibleGamingResetLimit() {
  return React.createElement(Translate, {
    id: 'action.responsible-gaming.reset-limit',
    defaultMessage: 'Reset limit'
  });
}), _defineProperty(_messages, 'action.responsible-gaming.accept', function actionResponsibleGamingAccept() {
  return React.createElement(Translate, { id: 'action.accept', defaultMessage: 'Accept' });
}), _defineProperty(_messages, 'action.responsible-gaming.pick', function actionResponsibleGamingPick() {
  return React.createElement(Translate, { id: 'action.pick.limit', defaultMessage: 'Pick' });
}), _defineProperty(_messages, 'label.responsible-gaming.confirm-increase', function labelResponsibleGamingConfirmIncrease(_ref) {
  var PendingActivateLimitAmount = _ref.PendingActivateLimitAmount;
  return React.createElement(Translate, {
    id: 'label.responsible-gaming.confirm-increase',
    defaultMessage: 'Would you like to accept your new limit of {Amount}?',
    values: { Amount: PendingActivateLimitAmount }
  });
}), _defineProperty(_messages, 'label.responsible-gaming.confirm-delete', function labelResponsibleGamingConfirmDelete() {
  return React.createElement(Translate, {
    id: 'label.responsible-gaming.confirm-delete',
    defaultMessage: 'Are you sure you want to delete your limit?'
  });
}), _defineProperty(_messages, 'label.responsible-gaming.pending-delete', function labelResponsibleGamingPendingDelete(_ref2) {
  var PendingDeleteLimitExpires = _ref2.PendingDeleteLimitExpires;
  return React.createElement(Translate, {
    id: 'label.responsible-gaming.pending-delete',
    defaultMessage: 'Your limit will be removed {Time}',
    values: {
      Time: React.createElement(FormattedRelativeTime, selectUnit(new Date(PendingDeleteLimitExpires + '+00:00')))
    }
  });
}), _defineProperty(_messages, 'label.responsible-gaming.pending-activate', function labelResponsibleGamingPendingActivate(_ref3) {
  var PendingActivateLimitAmount = _ref3.PendingActivateLimitAmount,
      PendingActivateLimitActivates = _ref3.PendingActivateLimitActivates;
  return React.createElement(Translate, {
    id: 'label.responsible-gaming.pending-activate',
    defaultMessage: 'A new limit of {Amount} will be activated {Time}',
    values: {
      Amount: PendingActivateLimitAmount,
      Time: React.createElement(FormattedRelativeTime, selectUnit(new Date(PendingActivateLimitActivates + '+00:00')))
    }
  });
}), _defineProperty(_messages, 'label.responsible-gaming.pending-review', function labelResponsibleGamingPendingReview(_ref4) {
  var PendingReviewLimitAmount = _ref4.PendingReviewLimitAmount;
  return React.createElement(Translate, {
    id: 'label.responsible-gaming.pending-review',
    defaultMessage: 'A new limit of {Amount} is pending support approval',
    values: { Amount: PendingReviewLimitAmount }
  });
}), _defineProperty(_messages, 'label.responsible-gaming.pick-limit', function labelResponsibleGamingPickLimit() {
  return React.createElement(Translate, {
    id: 'label.extra-limits',
    defaultMessage: 'You seem to have multiple limits on your account, pick the one you want.'
  });
}), _defineProperty(_messages, 'alert_message.warning.responsible-gaming.rule.deposit.insufficient-limit-count', function alert_messageWarningResponsibleGamingRuleDepositInsufficientLimitCount() {
  return React.createElement(Alert, {
    id: 'alert_message.warning.responsible-gaming.rule.deposit.insufficient-limit-count',
    defaultMessage: 'You need at least one deposit limit.',
    level: 'warning',
    scrollIntoView: false
  });
}), _defineProperty(_messages, 'alert_message.warning.responsible-gaming.rule.requires-self-test', function alert_messageWarningResponsibleGamingRuleRequiresSelfTest() {
  return React.createElement(Alert, {
    id: 'alert_message.warning.responsible-gaming.rule.requires-self-test',
    defaultMessage: 'You will be asked to complete a self test survey when you increase or remove a limit.',
    level: 'warning',
    scrollIntoView: false
  });
}), _defineProperty(_messages, 'alert_message.warning.responsible-gaming.rule.self-test-fail-cooldown', function alert_messageWarningResponsibleGamingRuleSelfTestFailCooldown(_ref5) {
  var DepositIncreaseBlockExpires = _ref5.DepositIncreaseBlockExpires;
  return React.createElement(Alert, {
    id: 'alert_message.danger.limits.self-test-fail-cooldown',
    defaultMessage: 'You are not eligible to increase your limits. You can redo the self test {expires}.',
    level: 'danger',
    scrollIntoView: false,
    values: {
      expires: React.createElement(FormattedRelativeTime, selectUnit(new Date(DepositIncreaseBlockExpires + '+00:00')))
    }
  });
}), _defineProperty(_messages, 'alert_message.warning.responsible-gaming.rule.support-pending', function alert_messageWarningResponsibleGamingRuleSupportPending() {
  return React.createElement(Alert, {
    id: 'alert_message.danger.limits.support-pending',
    defaultMessage: 'You have requested a limit raise. Your request is pending until support have approved it.',
    level: 'danger',
    scrollIntoView: false
  });
}), _defineProperty(_messages, 'alert_message.warning.responsible-gaming.rule.deposit.limit-increase-blocked', function alert_messageWarningResponsibleGamingRuleDepositLimitIncreaseBlocked(_ref6) {
  var DepositIncreaseBlockExpires = _ref6.DepositIncreaseBlockExpires;
  return React.createElement(Alert, {
    id: 'alert_message.danger.limits.deposit-limit-increase-blocked',
    defaultMessage: 'You are blocked from increasing deposit limits. Your block will expire {expires}.',
    level: 'danger',
    scrollIntoView: false,
    values: {
      expires: React.createElement(FormattedRelativeTime, selectUnit(new Date(DepositIncreaseBlockExpires + '+00:00')))
    }
  });
}), _defineProperty(_messages, 'label.responsible-gaming.option.current-limit', function labelResponsibleGamingOptionCurrentLimit(_ref7) {
  var intl = _ref7.intl,
      currentLimit = _ref7.currentLimit;
  return translate({
    id: 'label.responsible-gaming.option.current-limit',
    defaultMessage: '{Amount} (Current limit)',
    values: { Amount: currentLimit }
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.option.no-limit', function labelResponsibleGamingOptionNoLimit(_ref8) {
  var intl = _ref8.intl;
  return translate({
    id: 'label.responsible-gaming.option.no-limit',
    defaultMessage: 'No limit'
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.option.other', function labelResponsibleGamingOptionOther(_ref9) {
  var intl = _ref9.intl;
  return translate({
    id: 'label.responsible-gaming.option.other',
    defaultMessage: 'Other'
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.option.other-minutes', function labelResponsibleGamingOptionOtherMinutes(_ref10) {
  var intl = _ref10.intl;
  return translate({
    id: 'label.responsible-gaming.option.other-minutes',
    defaultMessage: 'Other (Minutes)'
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.option.other-hours', function labelResponsibleGamingOptionOtherHours(_ref11) {
  var intl = _ref11.intl;
  return translate({
    id: 'label.responsible-gaming.option.other-hours',
    defaultMessage: 'Other (Hours)'
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.option.other-days', function labelResponsibleGamingOptionOtherDays(_ref12) {
  var intl = _ref12.intl;
  return translate({
    id: 'label.responsible-gaming.option.other-days',
    defaultMessage: 'Other (Days)'
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.option.other-weeks', function labelResponsibleGamingOptionOtherWeeks(_ref13) {
  var intl = _ref13.intl;
  return translate({
    id: 'label.responsible-gaming.option.other-weeks',
    defaultMessage: 'Other (Weeks)'
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.option.other-months', function labelResponsibleGamingOptionOtherMonths(_ref14) {
  var intl = _ref14.intl;
  return translate({
    id: 'label.responsible-gaming.option.other-months',
    defaultMessage: 'Other (Months)'
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.option.other-years', function labelResponsibleGamingOptionOtherYears(_ref15) {
  var intl = _ref15.intl;
  return translate({
    id: 'label.responsible-gaming.option.other-years',
    defaultMessage: 'Other (Years)'
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.unlimited', function labelResponsibleGamingUnlimited(_ref16) {
  var intl = _ref16.intl;
  return translate({
    id: 'label.responsible-gaming.unlimited',
    defaultMessage: 'Unlimited'
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.currency', function labelResponsibleGamingCurrency(_ref17) {
  var intl = _ref17.intl,
      value = _ref17.value,
      currency = _ref17.currency;
  return intl.formatNumber(value, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
}), _defineProperty(_messages, 'label.responsible-gaming.minutes', function labelResponsibleGamingMinutes(_ref18) {
  var intl = _ref18.intl,
      value = _ref18.value;
  return translate({
    id: 'label.responsible-gaming.minutes',
    defaultMessage: '{Amount, plural, one {# minute} other {# minutes}}',
    values: { Amount: value }
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.hours', function labelResponsibleGamingHours(_ref19) {
  var intl = _ref19.intl,
      value = _ref19.value;
  return translate({
    id: 'label.responsible-gaming.hours',
    defaultMessage: '{Amount, plural, one {# hour} other {# hours}}',
    values: { Amount: value }
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.days', function labelResponsibleGamingDays(_ref20) {
  var intl = _ref20.intl,
      value = _ref20.value;
  return translate({
    id: 'label.responsible-gaming.days',
    defaultMessage: '{Amount, plural, one {# day} other {# days}}',
    values: { Amount: value }
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.weeks', function labelResponsibleGamingWeeks(_ref21) {
  var intl = _ref21.intl,
      value = _ref21.value;
  return translate({
    id: 'label.responsible-gaming.weeks',
    defaultMessage: '{Amount, plural, one {# week} other {# weeks}}',
    values: { Amount: value }
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.months', function labelResponsibleGamingMonths(_ref22) {
  var intl = _ref22.intl,
      value = _ref22.value;
  return translate({
    id: 'label.responsible-gaming.months',
    defaultMessage: '{Amount, plural, one {# month} other {# months}}',
    values: { Amount: value }
  }, intl);
}), _defineProperty(_messages, 'label.responsible-gaming.years', function labelResponsibleGamingYears(_ref23) {
  var intl = _ref23.intl,
      value = _ref23.value;
  return translate({
    id: 'label.responsible-gaming.years',
    defaultMessage: '{Amount, plural, one {# year} other {# years}}',
    values: { Amount: value }
  }, intl);
}), _defineProperty(_messages, 'alert_message.warning.responsible-gaming.admin-limits', function alert_messageWarningResponsibleGamingAdminLimits(_ref24) {
  var adminLimits = _ref24.adminLimits;
  return React.createElement(Alert, {
    id: 'alert_message.warning.responsible-gaming.admin-limits',
    defaultMessage: 'Please note that we have locked the following limits on your account. These limits will apply even if you choose higher amounts in the boxes below. {AdminLimits} Contact support for further information.',
    level: 'warning',
    values: { AdminLimits: adminLimits },
    scrollIntoView: false
  });
}), _defineProperty(_messages, 'label.responsible-gaming.admin-limits-row', function labelResponsibleGamingAdminLimitsRow(_ref25) {
  var intl = _ref25.intl,
      Timespan = _ref25.Timespan,
      Amount = _ref25.Amount,
      Product = _ref25.Product;
  return translate({
    id: 'label.responsible-gaming.admin-limits-row',
    defaultMessage: '{Timespan, select,\n          0 {Transaction}\n          1 {Daily}\n          7 {Weekly}\n          30 {Monthly}\n          other {Other}\n        }: {Amount} {Product, select,\n          Casino {(Only applies for casino games)}\n          other {}\n        }',
    values: { Timespan: Timespan, Amount: Amount, Product: Product }
  }, intl);
}), _messages);

export default { get: get, getValue: getValue };